import { PointerType } from './pointer-type';

export class ChangeContext {
  value: number;
  highValue?: number;
  pointerType: PointerType;
}
